export default "__VITE_ASSET__BLOTqh3Q__"